/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{border-left:4px solid #f7931d;display:block;padding:0 10px 8px;margin-bottom:24px}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#182365}"];
export { styles as styles };
